import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate, MdAdd, MdTransferWithinAStation } from 'react-icons/md'
import { BsPlusSquareFill } from 'react-icons/bs'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import classnames from 'classnames'
import PosShippingForm from '../components/PosShippingForm'
import { IconContext } from 'react-icons/lib'
import PosPromoTable from './PosPromoTable'

class PosPromoForm extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isEdit: false,
      isGlobal: true,
      id: '',
      name: '',
      promo_code: '',
      promo_type: '',
      options: '',
      mod_value: '',
      compare_type: '',
      compare_value: '',
      start_date: '',
      end_date: '',
      issue_limit: 0,
      claim_limit: 0,
      issued: '',
      shippingList: [],
      promoList: [],
    }
  }

  componentDidMount() {
    this.Shipping()
    this.Promo()
    if (this.props.data.isGlobal) {
      if (this.props.data.isEdit) {
        let id = this.props.data.selectedId
        const data = this.props.data.promoList.find(e => e.id === id)
        this.setState({
          id: id,
          name: data.name,
          promo_code: data.promo_code,
          promo_type: data.promo_type,
          options: data.options,
          mod_value: data.mod_value,
          compare_type: data.compare_type,
          compare_value: data.compare_value,
          start_date: data.start_date,
          end_date: data.end_date,
          issue_limit: data.issue_limit,
          claim_limit: data.claim_limit,
          issued: data.issued,
          isEdit: true,
          isGlobal: this.props.data.isGlobal,
        })
      }
    } else {
      this.setState({
        store_id: this.props.data.store_id,
        isGlobal: this.props.data.isGlobal,
      })
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  changeHandler = e => {
    let { name, value } = e.target
    if (name === 'mod_value') {
      if (value.includes('.')) {
        let decimal = value.split('.')[1]
        if (decimal.length > 2) {
          value = value.slice(0, -1)
        }
      }
    }

    if (name === 'promo_code') {
      value = value.replace(/\s/g, '')
    }

    this.setState({
      [name]: value,
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    if (this.state.isGlobal) {
      if (!this.state.isEdit) {
        this.create(user, comp, url)
      } else {
        this.update(user, comp, url)
      }
    } else {
      this.add(user, comp, url)
    }
  }

  Promo = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/promo', data)
      .then(response => {
        const result = response.data
        const storePromo = this.props.data.promoList

        let PromoOp = result.data.filter(x => !storePromo.some(y => y.id === x.id))

        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        if (this._isMounted) {
          this.setState({
            promoList: PromoOp,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  Shipping = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/shipping', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        if (this._isMounted) {
          this.setState({
            shippingList: result.data,
            // store_id: store_id,
            // isGlobal: this.props.isGlobal,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  create(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      name: this.state.name,
      promo_code: this.state.promo_code,
      promo_type: this.state.promo_type,
      options: this.state.options,
      mod_value: this.state.mod_value,
      compare_type: this.state.compare_type,
      compare_value: this.state.compare_value,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      issue_limit: this.state.issue_limit,
      claim_limit: this.state.claim_limit,
      issued: this.state.issued,
      created_by: user.email,
    }

    axios
      .post(url + ':3001/v1/promo/create', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'New promo added successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  update(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      id: this.state.id,
      name: this.state.name,
      promo_code: this.state.promo_code,
      promo_type: this.state.promo_type,
      options: this.state.options,
      mod_value: this.state.mod_value,
      compare_type: this.state.compare_type,
      compare_value: this.state.compare_value,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      issue_limit: this.state.issue_limit,
      claim_limit: this.state.claim_limit,
      issued: this.state.issued,
      update_by: user.email,
    }

    axios
      .post(url + ':3001/v1/promo/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(
          <MdDone />,
          'Promo details updated successfully.',
          'success', //'error' post when return error
          false,
        )
      })
      .catch(error => {
        alert(error)
      })
  }

  add(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      promo_id: this.state.promo_id,
      added_by: user.email,
    }

    axios
      .post(url + ':3001/v1/store/promo/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'New Promo added successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>Promo {this.state.isGlobal ? 'Details' : 'List'}</ModalHeader>
        <ModalBody>
          {this.state.isGlobal ? (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label>Name</Label>
                  <Input type="text" name="name" value={this.state.name} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup>
                  <Label>Promo Code</Label>
                  <Input type="text" name="promo_code" value={this.state.promo_code} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup>
                  <Label>Promo Type</Label>
                  <Input type="select" name="promo_type" value={this.state.promo_type} onChange={this.changeHandler} required>
                    <option value=""></option>
                    <option value="SHIPPING">SHIPPING</option>
                    <option value="DISCOUNT">DISCOUNT</option>
                  </Input>
                </FormGroup>
                <FormGroup>
                  <Label>Option</Label>
                  <Input type="select" name="options" value={this.state.options} onChange={this.changeHandler} required>
                    {this.state.promo_type === 'SHIPPING' && (
                      <>
                        <option value=""></option>
                        {this.state.shippingList.length > 0 &&
                          this.state.shippingList.map(item => {
                            return (
                              <option key={item.id} value={item.shipping_code}>
                                {item.shipping_code}
                              </option>
                            )
                          })}
                      </>
                    )}
                    {this.state.promo_type === 'DISCOUNT' && (
                      <>
                        <option value=""></option>
                        <option value="FIXED">FIXED</option>
                        <option value="PERCENT">PERCENT</option>
                      </>
                    )}
                  </Input>
                </FormGroup>
                <FormGroup>
                  <Label>Mod Value</Label>
                  <Input type="text" name="mod_value" value={this.state.mod_value} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup>
                  <Label>Compare Type</Label>
                  <Input type="select" name="compare_type" value={this.state.compare_type} onChange={this.changeHandler} required>
                    <option value=""></option>
                    <option value="FREE">FREE</option>
                    <option value="EQUAL">EQUAL{'(=)'}</option>
                    <option value="MORETHAN">MORETHAN {'(≥)'}</option>
                    <option value="LESSTHAN">LESSTHAN {'(≤)'}</option>
                  </Input>
                </FormGroup>
                <FormGroup>
                  <Label>Compare Value</Label>
                  <Input type="text" name="compare_value" value={this.state.compare_value} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup>
                  <Label>Start Date</Label>
                  <Input type="date" name="start_date" value={this.state.start_date} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup>
                  <Label>End Date</Label>
                  <Input type="date" name="end_date" value={this.state.end_date} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup>
                  <Label>Issue Limit (0 equal no limit)</Label>
                  <Input type="text" name="issue_limit" value={this.state.issue_limit} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup>
                  <Label>Claim Limit (0 equal no limit)</Label>
                  <Input type="text" name="claim_limit" value={this.state.claim_limit} onChange={this.changeHandler} required />
                </FormGroup>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label></Label>
                  <Input type="select" name="promo_id" onChange={this.changeHandler} required>
                    <option></option>
                    {this.state.promoList &&
                      this.state.promoList.map(item => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        )
                      })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    )
  }
}

export default PosPromoForm
